import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/services/auth.service";


@Component({
    selector: 'mwp-dialog-account-delete',
    templateUrl: './delete-account.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DialogAccountDeleteComponent {
    public isChecked = false;

    constructor(
        private authService: AuthService,
        private dialogRef: MatDialogRef<DialogAccountDeleteComponent>,
    ) {
    }

    public buttonClicked(): void {
        this.authService.deleteAccount().subscribe(() => {
            this.dialogRef.close();
        });
    };

    public close(): void {
        this.dialogRef.close();
    }
}